// extracted by mini-css-extract-plugin
module.exports = {"highlightedNonActive":"HighlightedText-module__highlightedNonActive___7ivew","highlightedActive":"HighlightedText-module__highlightedActive___2i6_m"};